module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'app--fullheight': _vm.isFullHeightLayout
    },
    attrs: {
      "id": "app"
    }
  }, [_c('Outdated', {
    ref: "outdated"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "site-header"
  }, [_c('a', {
    staticClass: "custom-logo",
    attrs: {
      "href": _vm.$utils.getWpPath('')
    }
  }, [_c('img', {
    staticClass: "logo-domain",
    attrs: {
      "src": require("./assets/domain-custom/base/eef-logo.png"),
      "srcset": ((_vm.images.logo1) + " 1x, " + (_vm.images.logo2) + " 2x"),
      "alt": _vm.$config.WEBSITE_NAME + 'Shop Logo'
    }
  })])]), _vm._v(" "), (_vm.showCartStatus) ? _c('cart-status-icon') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isFullHeightLayout) ? _c('full-height-layout', {
    key: _vm.$route.fullPath
  }, [_c('router-view', {
    staticClass: "app-frame-inner"
  })], 1) : _c('router-view', {
    key: _vm.$route.fullPath,
    staticClass: "app-frame-inner"
  })], 1), _vm._v(" "), _c('site-footer'), _vm._v(" "), _c('login-modal', {
    ref: "loginModal"
  }), _vm._v(" "), _c('vue-toast', {
    ref: "toast"
  }), _vm._v(" "), _c('vue-modal', {
    ref: "modal"
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-be6636de", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be6636de","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 759
// module chunks = 1